module.exports = __webpack_public_path__ + "img/rin kaenbyou_lw.76ab7b92.png";